
// src/web/components/comfirm-dialog.jsx

import React from 'react'
import { translate } from 'react-i18next'
import Dialog from 'react-toolbox/lib/dialog'
import FontIcon from 'react-toolbox/lib/font_icon'

function ConfirmDialog(props) {
  const {
    t,
    open = false,
    title,
    description,
    yesLabel,
    noLabel,
    onYes,
    yesHref,
    noHref,
    onNo,
    reTrialMessage,
    centeredTitle,
    configBaseUrl,
    trialDatesMessage,
  } = props

  return (
    <Dialog active={open}
        onEscKeyDown={onNo}
        onOverlayClick={onNo}
        title={centeredTitle ? <div style={{textAlign: 'center', fontWeight: 'bold'}}>{title}</div> : <div><FontIcon value='warning'/>&nbsp;&nbsp;{title}</div>}
        actions={[
          { label: noLabel || t('label:いいえ'), onClick: onNo, href: noHref, raised: true },
          { label: yesLabel || t('label:はい'), onClick: onYes, href: yesHref, raised: true, primary: true, target: yesHref && '_blank' || undefined, rel: yesHref && "noopener noreferrer" || undefined },
        ]}>
      {reTrialMessage ? 
        <div style={{whiteSpace: "pre-line"}}>
          {description}
          <div style={{fontSize: 14, marginTop: 10}}>{t('label:ご契約を希望のお客様')}<a href={`${configBaseUrl}v3/contract`} target="_blank" rel="noopener noreferrer">{t('label:こちら')}</a>{t('label:お申し込みください')}</div>
        </div> : description}
        {trialDatesMessage &&
        <div style={{whiteSpace: "pre-line"}}>
          <div style={{fontSize: 16}}>
            {t('label:gamba!をご利用いただきありがとうございました')}
            {t('label:ご契約を希望のお客様')}
            <a href={`${configBaseUrl}v3/contract`} target="_blank" rel="noopener noreferrer">{t('label:こちら')}</a>
            {t('label:お申し込みください')}
          </div>
        </div>
        }
    </Dialog>
  )
}

export default translate()(ConfirmDialog)



// WEBPACK FOOTER //
// ./src/web/components/confirm-dialog.jsx